import React from 'react';
import PropTypes from 'prop-types';
import {
  formatTime12Hour,
  formatDateTimeFromNow,
} from '../../../../utils/formatDate';

export default function SubmissionFieldTime({
  context,
  question,
  value,
  formatter = formatTime12Hour,
}) {
  const str =
    question.config.relative === true
      ? formatDateTimeFromNow(value)
      : formatter(value);

  return (
    <time dateTime={value} title={formatter(value)}>
      {str}
    </time>
  );
}

SubmissionFieldTime.propTypes = {
  context: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
  formatter: PropTypes.func,
};
